// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__9XpG-","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2BLzo"};